/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Helmet } from 'react-helmet';
import { Footer, Header, Programs } from '../components';

const Download = () => {
	return (
		<>
			<Helmet>
				<title>İndirme Bağlantıları | Radyospor - Türkiye'nin İlk Spor Radyosu</title>
			</Helmet>

			<Header />

			<div className="container">
				<main className="download">
					<div className="row">
						<div className="col-lg-12">
							<div className="section-title">İndirme Bağlantıları</div>

							<div className="download-content">
								<div className="download-item">
									<h2>Play Store üzerinden indirin</h2>
									<a href="https://play.google.com/store/apps/details?id=com.radyospor" target="_blank" rel="noopener noreferrer">
										<img src="/assets/images/Googleplay.svg" alt="Android İndir" />
									</a>
								</div>
								<div className="download-item">
									<h2>App Store üzerinden indirin</h2>
									<a href="https://apps.apple.com/tr/app/radyospor/id880633790" target="_blank" rel="noopener noreferrer">
										<img src="/assets/images/Appstore.svg" alt="iOS İndir" />
									</a>
								</div>
							</div>
						</div>
					</div>

					<Programs />
				</main>
			</div>

			<Footer />
		</>
	);
};

export default Download;
